import { LogManager } from '../../../common/port/log/log.manager.port';
import { AccountSentimentReportAverageTimeSeriesAggregateRootMapper } from '../../../infrastructure/mappers/sentiment/account-sentiment-report-average-time-series-aggregate-root.mapper';
import { GetAccountSentimentReportAverageTimeSeriesRequestDto } from '../../dtos/sentiment/get-account-sentiment-report-average-time-series.request.dto';
import { GetAccountSentimentReportAverageTimeSeriesResponseDto } from '../../dtos/sentiment/get-account-sentiment-report-average-time-series.response.dto';
import { GetAccountSentimentReportAverageTimeSeriesQuery } from '../../queries/sentiment/get-account-sentiment-report-average-time-series.query';

export class GetAccountSentimentReportAverageTimeSeriesController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly query: GetAccountSentimentReportAverageTimeSeriesQuery,
    protected readonly mapper: AccountSentimentReportAverageTimeSeriesAggregateRootMapper
  ) {}

  async get(
    props: GetAccountSentimentReportAverageTimeSeriesRequestDto
  ): Promise<GetAccountSentimentReportAverageTimeSeriesResponseDto> {
    try {
      const result = await this.query.execute(props);
      return result.map((res) => this.mapper.toResponse(res));
    } catch (error) {
      throw new Error(
        `GetAccountSentimentReportAverageTimeSeriesController.get encountered an error ${error}`
      );
    }
  }
}
